import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

export const App = styled.div`
  display: flex;
  position: relative ;
  flex-direction: column;
  width: 100vw ;
  height: 92vh;
  margin-top:50px ;
  background-color: #2b2b2b;
  overflow: hidden ; 
  font-size: clamp(11px, 3vw, 16px);
  align-items: center ;
  
  
  .fundoBloque{
  display: ${props => props.fundoBloque ? 'flex' : 'none'} ;
  width: 100vw;
  height: 100vh; 
  background-color: rgb(20, 20, 20) ;
  position: fixed ;
  z-index: 5 ;
  };

  button{
    cursor: pointer;
    border:none;
    font-weight:bold ;
  };
  
`

export const body = styled.div`
display: ${props => props.CarregarTela ? 'flex' : 'none'} ;;
width: 100vw ;
max-width: 500px ;
height: 90vh ;
padding: 0 10px ;
padding-bottom: 15px ;
font-size: 12px;
position: relative ;
flex-direction: column ;
color: white;
align-items: center ;
background-color: black;

.tituloHover{
  color: white ;
  &:hover{
    color: yellow ;
  }
}

@media ${breakpoints.sm} {
  width:100vw ;
}

`

// -----------------------------
export const Inicio = styled.div` 
display: flex;
flex-direction: column ;
align-items: center ;
justify-content: center ;
margin-top: 15px ;
width: 100% ;
`
// -----------------------------
export const containerPesq = styled.div` 
display: flex;
flex-direction: column ;
align-items: center ;
`

// -----------------------------
export const VistoriaModal = styled.div`
display: ${props => props.CarregarTela ? 'flex' : 'none'} ;
flex-direction: column ;
align-items: center ;
width:95vw ;
max-width:500px ;
height:85vh ;
padding-top:10px ;
overflow-y: auto ;
overflow-x: hidden ;
gap:5px ;
margin-bottom: 20px ;

`
// -----------------------------
export const IconBar = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 8px 4px;

  & > button {
    flex: 0 1 calc((100% - 32px) / 5);
    min-width: 55px;
  }

  @media ${breakpoints.sm} {
    & > button {
      min-width: 60px;
    }
  }
`

export const IconButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 6px;
  border-radius: 10px;
  font-size: 11px;
  background: ${props => (props['aria-pressed'] ? '#00D594' : '#111827')};
  color: ${props => (props['aria-pressed'] ? '#0b0f14' : '#e5e7eb')};
  box-shadow: ${props => (props['aria-pressed'] ? '0 0 0 2px #00D594' : '0 0 0 1px #1f2937')};
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  .icon{
    font-size: 18px;
    line-height: 1;
  }

  &:hover{
    transform: translateY(-1px);
    box-shadow: 0 0 0 2px #2563eb;
  }

  &:disabled{
    opacity: 0.4;
    cursor: not-allowed;
    transform: none;
    box-shadow: 0 0 0 1px #1f2937;
  }
`

export const PanelCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 450px;
  padding: 16px 14px;
  border-radius: 12px;
  background: #0b0f14;
  box-shadow: 0 10px 30px rgba(0,0,0,0.35);
  border: 1px solid #1f2937;
`

export const CondutorModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  background: black;
  z-index: 10;
  padding: 20px;
`

export const CondutorModalCard = styled.div`
  display: flex;
  position: fixed ;
  width: 90vw ;
  top: 80px ;
  max-width: 400px;
  background: #0b0f14;
  border: 1px solid #1f2937;
  border-radius: 12px;
  padding: 18px 16px;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.4);
  color: #e5e7eb;
  overflow: hidden;
  box-sizing: border-box;
  z-index: 6;
`

export const CondutorModalTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  text-align: center;
`

export const CondutorModalButtons = styled.div`
  display: flex;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;
  box-sizing: border-box;

  button{
    flex: 1 1 140px;
    min-width: 0;
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    font-weight: bold;
    background: #1f2937;
    color: #e5e7eb;
    transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  }

  button:hover{
    transform: translateY(-1px);
    box-shadow: 0 0 0 2px #2563eb;
  }

  button:first-child{
    background: #00D594;
    color: #0b0f14;
  }
`

export const SinistroHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 6px 4px;

  button{
    background-color: #ef4444;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-weight: bold;
  }
`
// -----------------------------
export const ModalConteine = styled.div`
display: flex ;
flex-direction: column ;
align-items: center ;


.detalhes{
  display: flex ;
  flex: 1 ;
  flex-direction: column ;
}


`
// ------------------------------
export const Selfie = styled.div`
display: flex ;
justify-content: center ;
align-items: center ;
width:100% ;
height: 30vh ;

button{
  display:flex ;
  height: 50px ;
  align-items:center ;
  padding: 10px 20px ;
  background-color:#a5acca ;
  color: black ;
  border-radius:5px ;
  margin-top:15px ;
}

`

// ------------------------------
export const Modal = styled.div`
display: flex ;
overflow:auto ;
flex-direction: column ;

button{
  background-color:#00D594;
  min-width: 110px;
  min-height:34px;
  margin:3px;
  justify-content:center;
  border:none;
  border-radius:8px;
  color:${props => props.editModal ? 'white' : 'black'};
  cursor: pointer;
  font-weight: 600;
  transition: all .2s ease;

  &:hover{
    filter: brightness(1.05);
    transform: translateY(-1px);
  }

}
`
//-----------------------------------
export const bodyColunas = styled.div`
  display:flex ;
  overflow:auto ;
  width:95% ;

  @media ${breakpoints.sm} {
    justify-content: center ;
  }
`
// -------------------------------

// ------------------------------------
export const box = styled.div` 
display:flex;
gap: 5px;
position: relative ;
justify-content:space-between ;
flex-direction: column ;

.listaFlexCol{
  display: flex ;
  flex-direction: column ;
  text-transform:capitalize;
  color: white ;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.listaFlexRow{
  display: flex ;
  flex-direction: row ;
  text-transform:capitalize;
  color: white ;
  gap:5px ;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

`
//-------------------Resultado-------------------------------
export const bodyresult = styled.div`
display: flex ;
width:95% ;
align-items: start ;


.abrirModal{
  display:flex;
  max-width: 90px ;
  min-width: 90px;
  height:17px;
  align-items: center ;
  justify-content: center ;
  background-color:#3881ff;
  border-radius:1px;
  padding-bottom: 2px;
  font-size: 12px ;
  
  cursor:pointer ;

}

`
